import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Grid, Card, CardContent, CardMedia, Chip } from '@mui/material';
import api, { getMediaUrl } from '../services/api';

const PracticeAreas = () => {
  const [practiceAreas, setPracticeAreas] = useState([]);

  useEffect(() => {
    const fetchPracticeAreas = async () => {
      try {
        const response = await api.get('/practice-areas');
        setPracticeAreas(response.data);
      } catch (error) {
        console.error('Error fetching practice areas:', error);
      }
    };
    fetchPracticeAreas();
  }, []);

  return (
    <Container sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h3" gutterBottom>
          Practice Areas
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
          Comprehensive legal services across various domains of law
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {practiceAreas.length > 0 ? (
          practiceAreas.map((area) => (
            <Grid item xs={12} md={6} key={area._id}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
                {area.image && (
                  <CardMedia
                    component="img"
                    sx={{ width: { xs: '100%', md: 300 }, height: { xs: 200, md: 'auto' } }}
                    image={getMediaUrl(area.image)}
                    alt={area.title}
                  />
                )}
                <CardContent sx={{ flex: 1 }}>
                  <Typography variant="h5" gutterBottom>
                    {area.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" paragraph>
                    {area.description}
                  </Typography>
                  {area.services && area.services.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Services Include:
                      </Typography>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {area.services.map((service, index) => (
                          <Chip key={index} label={service} size="small" />
                        ))}
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography variant="body1" align="center" color="text.secondary">
              Practice areas will be displayed here. Please check back soon.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default PracticeAreas;

